module.exports = __webpack_public_path__ + "img/tokenBox24.0970a830.png";